import { createContext, useEffect, useState } from "react";

export const AppContext = createContext();

const ContextProvider = ({ children }) => {
  const [isUserLogin, setUserLogin] = useState(false);
  const [employee, setEmployee] = useState(() => {
    const getData = localStorage.getItem("employeeData");
    if (getData === null) {
      setUserLogin(false);
      return {};
    } else {
      const parseData = JSON.parse(getData);
      setUserLogin(true);
      return parseData;
    }
  });
  const [employeeMailId, setEmployeeMailId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [employeeRole, setEmployeeRole] = useState("");
  const [empIdStatus, setEmpIdStatus] = useState("");
  const [students, setStudents] = useState([]);
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "home",
  );

  // Check login status once when app starts
  // useEffect(() => {
  //   const getData = localStorage.getItem("employeeData");
  //   console.log(getData);
  //   if (getData === null) {
  //     setUserLogin(false);
  //   } else {
  //     const parseData = JSON.parse(getData);
  //     setUserLogin(true);
  //     setEmployee(parseData);
  //   }
  // }, []);
  // Store login state when it changes
  useEffect(() => {
    const empData = {
      id: employeeMailId,
      status: isUserLogin,
      name: employeeName,
      role: employeeRole,
    };

    if (isUserLogin) {
      localStorage.setItem("employee", JSON.stringify(empData));
    }
  }, [isUserLogin, employeeMailId, employeeName, employeeRole, employee]);

  return (
    <AppContext.Provider
      value={{
        isUserLogin,
        setUserLogin,
        employeeMailId,
        setEmployeeMailId,
        employeeName,
        setEmployeeName,
        employeeRole,
        setEmployeeRole,
        activeTab,
        setActiveTab,
        students,
        setStudents,
        empIdStatus,
        setEmpIdStatus,
        employee,
        setEmployee,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default ContextProvider;
